import { getUrlParamsFetch, handleAxiosError, ROUTER_PATHS } from '@/shared';
import { erpApi } from '@/shared/axios/erp-api';
import {
  urlBackend,
} from '@/shared/constants/networking.constants';
import {
  AlertSeverityEnum,
  UseMutationsParams,
} from '@/shared/interfaces';
import { IPreventaPymes, IPreventaPymesForm, IPreventaPymesParams, IPreventaPymesResp } from '@/shared/interfaces/erp/ventas_pymes/preventa_pymes.interface';
import { useUiStore } from '@/store/ui';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { isAxiosError } from 'axios';

const { get, post, put } = erpApi();


export const useGetPreventasPymes = (params?: IPreventaPymesParams, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['preventapymes', ...Object.values(params || {})],
    queryFn: async () => {
      return await getPreventasPymes(params);
    },
    retry: false,
    enabled,
    refetchOnWindowFocus: false,
  });
};

export const getPreventasPymes = async (params?: IPreventaPymesParams) => {
  const queryParams = getUrlParamsFetch(params || {});

  const resp = await get<IPreventaPymesResp>(
    `${urlBackend}api/v1/preventapymes/?${queryParams}`,
    true
  );

  return resp;
};

export const useFetchPostCreatePreventaPymes = ({
  navigate,
  returnUrl = ROUTER_PATHS.ventas.preventasNav
}: UseMutationsParams) => {
  const queryClient = useQueryClient();
  const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;

  const setConfirmDialog = useUiStore.getState().setConfirmDialog;
  const setConfirmDialogIsOpen = useUiStore.getState().setConfirmDialogIsOpen;
  const setAlert = useUiStore.getState().setAlert

  return useMutation({
    mutationFn: postCreatePreventaPymes,
    onSuccess: async (data, form) => {
      queryClient.invalidateQueries({ queryKey: ['preventapymes'] });

      if (data.code == 200) {
        setConfirmDialogIsOpen(true);
        setConfirmDialog({
          isOpen: true,
          title: '¡Creado con éxito!',
          subtitle: form.pre_requiere_contrato_fisico
            ? 'La preventa se ha creado correctamente. Pendiente subir el contrato firmado por el representante legal o la persona autorizada.'
            : 'La preventa se ha creado correctamente. El próximo paso es crear un preagendamiento cuando el cliente haya firmado el contrato digital.',
          onClose() {
            setConfirmDialogIsOpen(false);
            navigate && navigate(returnUrl)
          },
          onConfirm() {
            setConfirmDialogIsOpen(false);
            return navigate && navigate(returnUrl)
          },
          cancelTextBtn: 'Cerrar'
        });
      }
    },
    onError: error => {
      if (isAxiosError(error)) {
        const respError: any = error?.response?.data || {};
        switch (respError.code) {
          case 408:
            navigate && navigate(`${ROUTER_PATHS.ventasPymes.preventaNav}`)
            setAlert(true, 'La preventa se ha creado correctamente. [408]', AlertSeverityEnum.success)
            break
          default:
            handleAxiosError(error)
            break;
        }
      }
    },
    onSettled: () => {
      setIsGlobalLoading(false);
    }
  });
};

export const postCreatePreventaPymes = async (data: IPreventaPymesForm) => {
  const resp = await post<IPreventaPymes>(`${urlBackend}api/v1/preventapymes/`, data, true);
  return resp;
};

export const useGetPreventaPymesById = (id: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['preventapymes', id],
    queryFn: async () => {
      return await getPreventaPymesById(id);
    },
    enabled
  });
};

export const getPreventaPymesById = async (id: string) => {
  const resp = await get<IPreventaPymes>(`${urlBackend}api/v1/preventapymes/${id}`, true);
  return resp.data;
};


export const useFetchPutPreventaPymes = ({
  navigate,

  enableAlert = true,
  queryKey = 'preventapymes',

  enableRedirect = true,
  returnUrl,

  enableSuccessAlert = true,
  customSuccessMessage,

}: UseMutationsParams = {}) => {
  const queryClient = useQueryClient();
  const setAlert = useUiStore.getState().setAlert;
  //const setIsGlobalLoading = useUiStore.getState().setIsGlobalLoading;

  return useMutation({

    mutationFn: async (data: { id: string; data: IPreventaPymesForm }) =>
      putPreventaPymes(data),
    onSuccess: (data) => {

      queryClient.invalidateQueries({ queryKey: [queryKey, data.data.id_preventa_pymes] });
      queryClient.invalidateQueries({ queryKey: [queryKey] });

      enableRedirect && navigate && returnUrl && navigate(returnUrl);

      enableAlert && enableSuccessAlert &&
        setAlert &&
        setAlert(
          true,
          customSuccessMessage ?? 'Datos actualizados correctamente',
          AlertSeverityEnum.success
        );


    },
    onSettled: () => {
      //setIsGlobalLoading(false);
    },

  });
};


export const putPreventaPymes = async ({ id, data }:
  { id: string, data: IPreventaPymesForm }) => {

  const resp = await put<IPreventaPymes>(`${urlBackend}api/v1/preventapymes/${id}/`, data, true);
  return resp;
};
